module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-43.a731f26b.jpg";